<template>
  <div>
    <div v-if="showWholesaleNetsuiteForm">
      <WholesaleForm />
    </div>
    <form
      v-else
      class="c-contact-form"
      enctype="multipart/form-data"
      @submit.prevent="submit"
    >
      <template v-if="!submissionStatus.success">
        <h2 class="c-contact-form__title">
          {{ formTitle }}
        </h2>
        <div class="c-contact-form__container">
          <template v-for="input in formInputs">
            <section
              :key="input.sys.id"
              class="c-contact-form__section"
              :class="input.fields.desktopWidth.toLowerCase()"
            >
              <label
                class="c-contact-form__label"
                :for="input.fields.formFieldTitle"
              >{{
                 input.fields.formFieldTitle +
                   (input.fields.required ? " *" : "")
               }}
                <text-input
                  v-if="isTextInput(input)"
                  :id="input.fields.id"
                  class="c-contact-form__input"
                  :icon="getTextInputType(input) === 'email' ? 'envelope' : undefined"
                  :name="input.fields.formFieldTitle"
                  :required="input.fields.required"
                  :class="input.fields.inputType.toLowerCase()"
                  @input="updateField($event, input.fields.id)"
                />
                <input
                  v-else-if="isFile(input)"
                  :id="input.fields.id"
                  class="c-contact-form__input"
                  :type="input.fields.inputType.toLowerCase()"
                  :name="input.fields.formFieldTitle"
                  :required="input.fields.required"
                  :class="input.fields.inputType.toLowerCase()"
                  accept="image/*"
                  @input="updateField($event, input.fields.id)"
                >
                <div v-if="isMultiselect(input)">
                  <multiselect-radio-button
                    :options="input.fields.inputOptions"
                    :active-indexes="multiselectSelectedIndexes"
                    @input="onMultiselectChange($event, input.fields.id)"
                  />
                </div>
                <dropdown
                  v-else-if="isDropDown(input)"
                  class="c-contact-form__dropdown"
                  :type="input.fields.inputType.toLowerCase()"
                  :name="input.fields.formFieldTitle"
                  :required="input.fields.required"
                  :class="input.fields.inputType.toLowerCase()"
                  :options="input.fields.inputOptions"
                  @input="updateField($event, input.fields.id)"
                />
                <textarea
                  v-else-if="isTextArea(input)"
                  :id="input.fields.id"
                  class="c-contact-form__textarea"
                  :name="input.fields.formFieldTitle"
                  :required="input.fields.required"
                  rows="textAreaRows"
                  :class="input.fields.inputType.toLowerCase()"
                  @input="updateField($event, input.fields.id)"
                />
              </label>
            </section>
          </template>
        </div>
        <button
          type="submit"
          class="c-contact-form__submit"
        >
          Submit
        </button>
      </template>
      <div
        v-else
        class="c-contact-form__submitted"
      >
        {{ submissionText }}
      </div>
    </form>
  </div>
</template>

<script>
import TextInput from '../inputs/TextInput'
import MultiselectRadioButton from '../radioButton/MultiselectRadioButton'
import Dropdown from '../inputs/Dropdown'
import isString from 'lodash/isString'
import WholesaleForm from "./WholesaleForm";
export default {
  components: {
    Dropdown,
    TextInput,
    MultiselectRadioButton,
    WholesaleForm
  },
  props: {
    endpoint: {
      type: String,
      default: "https://hooks.zapier.com/hooks/catch/1353692/o351b1g/",
    },
    formTitle: {
      type: String,
      default: null,
    },
    formType: {
      type: String,
      default: null,
    },
    formInputs: {
      type: Array,
      default: () => [],
    },
    textAreaRows: {
      type: Number,
      default: 3,
    },
    submissionText: {
      type: String,
      default:
        "We've received your submission! We do our best to respond to these requests within 48 hours during the week.",
    },
    showWholesaleNetsuiteForm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      submissionStatus: {},
      multiselectSelectedValues: [],
      multiselectSelectedIndexes: [],
    };
  },
  computed: {
    formHandle() {
      return this.formTitle
        .toLowerCase()
        .replace(/[?!]/g, "")
        .replace(/\s+/g, "-")
        .trim();
    },
  },
  methods: {
    updateField(event, id) {
      let formData = {}
      if (event && event.target) {
        if (event.target.files) {
          formData[id] = event.target.files[0]
        } else {
          formData[id] = event.target.value
        }
      } else if (isString(event)) {
        if (id.toLowerCase().includes("email")) {
          formData[id] = event.replace(/\s+/g, "")
        } else {
          formData[id] = event
        }
      }
      this.formData = { ...this.formData, ...formData }
    },
    getTextInputType(input) {
      if (input.fields.inputType.toLowerCase() === "text") {
        if (input.fields.formFieldTitle.toLowerCase().includes("email")) {
          return "email"
        } else {
          return "text"
        }
      }
    },
    isTextInput(input) {
      return (
        input.fields.inputType.toLowerCase() === "text" &&
        !input.fields.resizable
      )
    },
    isTextArea(input) {
      return (
        input.fields.inputType.toLowerCase() === "text" &&
        input.fields.resizable
      )
    },
    isMultiselect(input) {
      return (
        input.fields &&
        input.fields.inputType.toLowerCase() === "multi-select radio buttons"
      )
    },
    onMultiselectChange(e, id) {
      this.formData[id] = e.selectedValues.join(", ")
      this.multiselectSelectedIndexes = e.activeIndexes
    },
    isDropDown(input) {
      if (input.fields.inputType.toLowerCase() === "dropdown") {
        return true
      } else {
        return false
      }
    },
    isFile(input) {
      return input.fields.inputType.toLowerCase() === "file";
    },
    validateEmail(email) {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
    },
    submit() {
      /** Depending on the type of help form, set the reason  to different actions **/
      if (this.formHandle === "contact-us") {
        this.formData.reason = "contact-general-help";
      } else if (this.formHandle === "pre-shipping-adjustment") {
        this.formData.reason = "Order Adjustment";
      } else if (this.formHandle === "where's-my-order") {
        this.formData.reason = "Shipping";
      } else if (typeof this.formHandle === "string") {
        this.formData.reason = this.formHandle;
      } else {
        this.formData.reason = "other";
      }
      const formData = new FormData();
      for (const [key, value] of Object.entries(this.formData)) {
        if (value !== undefined && value !== null) {
          formData.set(key, value)
        }
      }
      // FIXME maybe use axios instead?
      fetch(this.endpoint, {
        method: "POST",
        body: formData,
      }).then((res) => {
        if (res.ok) {
          this.submissionStatus = { success: true, error: null };
        } else if (res.error) {
          this.submissionStatus = { success: false, error: res.error };
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.c-contact-form {
  margin: 0 auto;
  width: calc(min(1170px, 90vw));
  padding: 2em 5vw;
  border: 2px solid #022840;
  font-family: Futura, Arial, sans-serif;
  &__title{
    margin: 1.5em auto;
  text-align: center;
  font-size: 3em;
  }
  &__label {
    font-size: 1em;
    color: #022840;
    font-weight: 400;
    margin-bottom: 0.25em;
  }
  &__container {
    padding-bottom: 0.5em;
  }
  &__section {
    display: flex;
    flex-direction: column;
    text-transform: uppercase;
    margin-bottom: 1em;
    input,
    textarea {
      display: block;
      width: 100%;
      border: 2px solid #022840;
      padding: 6px 12px;
      line-height: 1.42857143;
      color: #555;
      font-size: 14px;
      font-family: Futura, Arial, sans-serif;
      @include respond-min(tab-land) {
        min-height: 5em;
      }
    }
    input.file {
      padding: 0;
      border: none;
    }
  }
  &__submit {
    display: block;
    text-transform: uppercase;
    border: 2px solid #022840;
    background-color: #022840;
    color: #fff;
    min-width: 12em;
    font-size: 1.5em;
    margin: 3em auto;
    padding: 0.5em 0;
    @include respond-min(tab-land) {
      margin: 1em auto;
      padding: 0.5em 0;
    }
  }
  &__submitted {
    text-align: center;
  }
  &__section.half {
  @include respond-min(tab-land) {
    display: inline-block;
    width: calc(50% - 1em);
  }
  }
  &__section.half:nth-of-type(even) {
    @include respond-min(tab-land) {
      float: right;
    }
  }
}
</style>
